import { 
    aziendaModel,
    anagraficaModel,
    anagraficaFascicoloModel, 
    userModel, 
    fascicoloModel,
    prestazioneModel,
    anagraficaBancaDatiModel,
    baseComuneModel,
    baseSecurityAreaModel,
    userPermissionModel,
    procedureSosModel,
    allegatoModel,
    sosModel,
    signerModel,
    certificateModel
} from "../models";

export const createAziendaModel = (item,tenantModel) => {
    return new aziendaModel(
        item.Id,
        tenantModel.tenantId,
        item.Denominazione,
        item.Cf,
        item.PIva,
        item.AddrPaeseId,
        item.AddrProvinciaId,
        item.AddrProvincia,
        item.AddrComuneId,
        item.AddrComune,
        item.AddrIndirizzo,
        item.AddrN,
        item.AddrCap,
        item.CreatedOn,
        item.ModifiedOn,
        item.CreatedBy,
        item.ModifiedBy,
        item.MeteringSlotId
    )
}
export const createAnagraficaModel = (item) => {
    return new anagraficaModel(
        item.id ?? item.Id,
        item.cf ?? item.Cf,
        item.nome ?? item.Nome,
        item.cognome ?? item.Cognome,
        item.nascitaLuogo ?? item.NascitaLuogo,
        item.nascitaData ?? item.NascitaData,
        item.professione ?? item.Professione,
        item.denominazione ?? item.Denominazione,
        item.pIva ?? item.PIva,
        item.reaComune ?? item.ReaComune,
        item.reaN ?? item.ReaN,
        item.addrProvincia ?? item.AddrProvincia,
        item.addrComune ?? item.AddrComune,
        item.addrIndirizzo ?? item.AddrIndirizzo,
        item.addrN ?? item.AddrN,
        item.addrCap ?? item.AddrCap,
        item.addr2Provincia ?? item.Addr2Provincia,
        item.addr2Comune ?? item.Addr2Comune,
        item.addr2Indirizzo ?? item.Addr2Indirizzo,
        item.addr2N ?? item.Addr2N,
        item.addr2Cap ?? item.Addr2Cap,
        item.isPep ?? item.IsPep,
        item.isNotPepMoreThanYear ?? item.IsNotPepMoreThanYear,
        item.createdOn ?? item.CreatedOn,
        item.versionN ?? item.VersionN,
        item.versionDate ?? item.VersionDate,
        item.parentId ?? item.ParentId,
        item.isPg ?? item.IsPg,
        item.addrPaeseId ?? item.AddrPaeseId,
        item.addrProvinciaId ?? item.AddrProvinciaId,
        item.addrComuneId ?? item.AddrComuneId,
        item.addr2PaeseId ?? item.Addr2PaeseId,
        item.addr2ProvinciaId ?? item.Addr2ProvinciaId,
        item.addr2ComuneId ?? item.Addr2ComuneId,
        item.isDeleted ?? item.IsDeleted,
        item.genereId ?? item.GenereId,
        item.pepCarica ?? item.PepCarica,
        item.createdBy ?? item.CreatedBy,
        item.modifiedBy ?? item.ModifiedBy,
        item.modifiedOn ?? item.ModifiedOn,
        item.tenantId ?? item.TenantId,
        item.importDesc ?? item.ImportDesc,
        item.workspaceId ?? item.WorkspaceId,
        item.amlId ?? item.AmlId,
        item.office1Id ?? item.Office1Id,
        item.office2Id ?? item.Office2Id,
        item.pepRuolo ?? item.PepRuolo,
        item.tipoRedditoId ?? item.TipoRedditoId,
        item.tipoPatrimonioId ?? item.TipoPatrimonioId,
        item.capSociale ?? item.CapSociale,
        item.orgAmmin ?? item.OrgAmmin,
        item.descAttivita ?? item.DescAttivita,
        item.tipoRedditoAltro ?? item.TipoRedditoAltro,
        item.tipoPatrimonioAltro ?? item.TipoPatrimonioAltro,
        item.errWs ?? item.ErrWs,
        item.errWsNote ?? item.ErrWsNote,
        item.countryCode ?? item.CountryCode,
        item.status ?? item.Status,
        item.expiryDate ?? item.ExpiryDate,
        item.revisionWs ?? item.RevisionWs,
        item.modalitaIdentId ?? item.ModalitaIdentId,
        item.docTipoId ?? item.DocTipoId,
        item.docN ?? item.DocN,
        item.docRilDa ?? item.DocRilDa,
        item.docRilData ?? item.DocRilData,
        item.docScad ?? item.DocScad,
        item.apNome ?? item.ApNome,
        item.apCf ?? item.ApCf,
        item.identifiedByUser ?? item.IdentifiedByUser,
        item.identifiedOn ?? item.IdentifiedOn,
        item.anagraficaId ?? item.AnagraficaId,
        item.anagraficaFascicoli || [],
        item.atecoCode ?? item.AtecoCode,
        item.attivitaLavDescr ?? item.AttivitaLavDescr
    )
}
export const getEmptyAnagraficaModel = (paeseId,loggedUserId) => {
    return new anagraficaModel(
        0,
        "",
        "",
        "",
        "",
        new Date(),
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        false,
        false,
        new Date(),
        1,
        new Date(),
        0,
        false,
        89,
        null,
        null,
        null,
        null,
        null,
        false,
        null,
        "",
        loggedUserId,
        "",
        new Date(),
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        1,
        1,
        0,
        "",
        "",
        "",
        "",
        false,
        "",
        "IT",
        "",
        null,
        "",
        1,
        0,
        "",
        "",
        new Date(),
        null,
        "",
        "",
        loggedUserId,
        new Date(),
        0,
        []   
    )
}
export const createAnagraficaFascicoloModel = (item,fascicoloId,anagraficaId) => {
    return new anagraficaFascicoloModel(
        item.Id ?? item.id,
        anagraficaId,
        fascicoloId,
        item.TipoAnagId ?? item.tipoAnagId,
        item.TipoPartId ?? item.tipoPartId,
        item.TipoPartDesc ?? item.tipoPartDesc,
        item.DataFine ?? item.dataFine,
        item.TipoRapp ?? item.tipoRapp,
        item.TipoRappDesc ?? item.tipoRappDesc  
    );
}
export const getEmptyAnagraficaFascicoloModel = (fascicoloId,tipoAnag) => {
    return  new anagraficaFascicoloModel(
        0,
        0,
        fascicoloId,
        tipoAnag === "cliente" ? 1 : tipoAnag === "collegate" ? 3 : 5,
        0,
        "",
        null,
        0,
        ""
    );
}
export const createUserModel = (itemUser) => {
return new userModel(
        itemUser.UserId ?? itemUser.userId,
        itemUser.TenantId ?? itemUser.tenantId,
        itemUser.user?.Username ?? itemUser.username ?? itemUser.Username,
        itemUser.user?.Email ?? itemUser.email ?? itemUser.Email,
        itemUser.user?.Name ?? itemUser.name ?? itemUser.Name,
        itemUser.user?.Surname ?? itemUser.surname ?? itemUser.Surname,
        (itemUser.user?.Name ?? itemUser.name ?? itemUser.Name) + " " + (itemUser.user?.Surname ?? itemUser.surname ?? itemUser.Surname),
        itemUser.Type ?? itemUser.type,
        itemUser.user?.Locale ?? itemUser.locale ?? itemUser.UserLocale,
        itemUser.TenantTipoId ?? itemUser.tenantTipoId,
        itemUser.user?.IsRespAntiRic ?? itemUser.isRespAntiRic ?? itemUser.IsRespAntiRic,
        itemUser.base_tipo_tenant?.Value ?? itemUser.base_tipo_tenant?.value,
        itemUser.user?.IsActive ?? itemUser.isActive ?? itemUser.IsActive,
        itemUser.user?.IsDeleted ?? itemUser.isDeleted ?? itemUser.IsDeleted,
        itemUser.user?.IsBanned ?? itemUser.isBanned ?? itemUser.IsBanned,
        itemUser.user?.CreatedOn ?? itemUser.createdOn ?? itemUser.CreatedOn,
        itemUser.user?.Cf ?? itemUser.cf ?? itemUser.Cf,
        itemUser.user?.LastVersion ?? itemUser.lastVersion ?? itemUser.LastVersion,
        itemUser.user?.IsEnabledToCreateLawyers ?? itemUser.isEnabledToCreateLawyers ?? itemUser.IsEnabledToCreateLawyers,
        "",
        "",
        "",
        "",
        itemUser.user?.EmailTsId ?? itemUser.emailTsId ?? itemUser.EmailTsId
    )
}
export const createFascicoloModel = (item, status = false, statusReason = "", anagraficaFascicoli = [],prestazioni = []) => {
    return new fascicoloModel(
        item.Id ?? item.id,
        item.TenantId ?? item.tenantId,
        item.AziendaId ?? item.aziendaId,
        item.Name ?? item.name,
        item.Date ?? item.date,
        item.IsPrivate ?? item.isPrivate,
        item.CreatedOn ?? item.createdOn,
        item.ModifiedOn ?? item.modifiedOn,
        [],
        status,
        statusReason,
        item.CreatedBy ?? item.createdBy,
        item.ModifiedBy ?? item.modifiedBy,
        anagraficaFascicoli,
        prestazioni
    )
}
export const createPrestazioneModel = (item) => {
    const creatorName = item.user 
        ? `${item.user.Name || ""} ${item.user.Surname || ""}`.trim() 
        : "";
    return new prestazioneModel(
        item.Id,
        item.TipoKey,
        item.PrestazioneId,
        item.base_tipo_prestazione.Nome,
        item.base_tipo_prestazione.Rischio,
        item.base_tipo_prestazione.Regole,
        item.StartDate,
        item.EndDate,
        item.PaeseId,
        item.ProvinciaId,
        item.Provincia,
        item.CittaId,
        item.Citta,
        item.ScopoId,
        item.NaturaId,
        item.Descrizione,
        item.IsPrivate,
        item.CreatedOn,
        item.ModifiedOn,
        [],
        [],
        item.AstensioneMotivo,
        item.IsEsoneroObbAst,
        "",
        "",
        item.rischios,
        item.base_tipo_prestazione.BaseTenantTipoId,
        item.CreatedBy,
        item.ModifiedBy,
        item.SettoreAttivita,
        item.SettorePrestazione,
        item.Ragione,
        creatorName
    );
}
export const createAnagraficaBancaDatiModel = (item,itemModel) => {
    return new anagraficaBancaDatiModel(
        item.Id,
        itemModel.id,
        item.Repository,
        item.Infos,
        item.CreatedOn,
        item.CreatedBy
    )
}
export const createBaseComuneModel = (item) => {
    return new baseComuneModel(
        item.Id,
        item.Codice,
        item.Provincia,
        item.Nome,
        item.CodBelfiore,
        item.CodiceIstatStorico ?? item.codiceIstatStorico ?? null,
        item.CodiciIstatAttuali ?? item.codiciIstatAttuali ?? null,
        item.CodiciIstatStorici ?? item.codiciIstatStorici ?? null,
        item.CodiciBelfiore ?? item.codiciBelfiore ?? null,
    )
}
export const createBaseSecurityAreaModel = (item) => {
    return new baseSecurityAreaModel(
        item.Id,
        item.Key,
        item.Value,
        item.Description,
        item.Order
    )
}
export const createUserPermissionModel = (item,allAreaItems) => {
    return new userPermissionModel(
        item.Id,
        item.AziendaId,
        allAreaItems.filter((bsa) => bsa.key === item.Area)[0].key,
        item.CanRead,
        item.CanCreate,
        item.CanUpdate,
        item.CanDelete
    )
}
export const createProcedureSosModel = (item) => {
    return new procedureSosModel(
        item.id,
        item.aziendaId,
        item.nominativoReferenteSos,
        item.contributoColleghi,
        item.attivitaStrumentiAnomalie,
        item.prioritaAnomalie,
        item.strumentiSelezione,
        item.partenariati,
        item.soggettiEsterni,
        item.createdOn,
        item.modifiedOn,
        item.createdBy,
        item.modifiedBy
    )
}
export const createAllegatoModel = (item,tenantId) => {
    return new allegatoModel(
        item.id,
        tenantId,
        item.entityType,
        item.entityId,
        item.fileName,
        item.fileType,
        item.fileUrl,
        item.displayedName,
        item.createdOn,
        item.modifiedOn,
        item.createdBy,
        item.modifiedBy,
        item.signatureHubId,
        item.signatureStatus,
        item.signatureUrl,
        item.signedOn,
        item.signatureExpire,
        item.cctId,
        item.autoSendCCT
    )
}
export const createSosModel = (item) => {
    return new sosModel(
        item.Id,
        item.Date,
        item.Motivo,
        item.Note,
        item.ReceiptId,
        item.ReportedByUser,
        item.CreatedOn,
        item.ModifiedOn,
        item.CreatedBy,
        item.ModifiedBy,
        item.DateRicUif
    )
}

export const createSignerModel = (item) => {
    const completeNumber = item.completeNumber ?? "";
    const maskedCompleteNumber = completeNumber.length > 5
        ? `${completeNumber.slice(0, 3)}${"*".repeat(completeNumber.length - 6)}${completeNumber.slice(-3)}`
        : completeNumber;

    return new signerModel(
        item.id,
        item.itemId,
        item.fiscalCode,
        item.firstName,
        item.lastName,
        item.email,
        item.completeNumber,
        maskedCompleteNumber,
        item.enabled,
        (item.certificates || []).map((cert)=>createCertificateModel(cert))
    )
}

export const createCertificateModel = (item) => {
    return new certificateModel(
        item.id,
        item.type,
        item.identificationType,
        item.enabled,
        item.signatureFlowEnabled,
        item.status
    )
}

